module.exports = __webpack_public_path__ + "img/project-11.34a7c4f0.jpg";